<template>
    <div class="decorationApp">
      <div class="decorationMain">
        <div class="chooseHouse">
          <span class="c333">选择房屋:</span>
          <div class="houseSelect c25">
            <oSelect @changeOption="onChangeOption"  :selectData="selectData"></oSelect>
          </div>
        </div>
        <div class="constructionUnit">
          <span class="c333 mr10">施工单位:</span>
          <input class="c25" v-model="builder" type="text" placeholder="请输入施工单位名称">
        </div>
        <div class="constructionManager">
          <span class="c333 mr10">施工负责人:</span>
          <input class="c25" v-model="builderresponser" type="text" placeholder="请输入施工负责人">
        </div>
        <div class="planStartTime">
          <span class="c333 mr10">计划开始时间:</span>
          <div>
            <input type="date" v-model="buildebegindate" placeholder="请选择时间">
            <img class="float-r" src="/static/img/rightArr.png" style="width: .2rem;height: .4rem;">
          </div>
        </div>
        <div class="planEndTime">
          <span class="c333 mr10">计划终止时间:</span>
          <div>
            <input type="date" v-model="buildetenddate" placeholder="请选择时间">
            <img class="float-r" src="/static/img/rightArr.png" style="width: .2rem;height: .4rem;">
          </div>
        </div>
        <div class="constructionFile">
          <p class="c333 mb10">装修文件:</p>
          <div dlass="drawing mt10" v-for="(item,ind) in decorationList" :key="ind">
            <p class="drawingTitle mb10 c25">{{item.documentname}}</p>
            <ul>
              <li v-for="(src,index) in item.files" :key="index">
                <img class='preview' :src="src">
                <img class="close" @click="close(item,index)" src="../../../../static/img/closea.png">
              </li>
              <li>
                <input type='file' name="doc" :ref= "'choose' + ind" accept="image/*" @change='setImagePreview(item, $event)' hidden/>
                <img class="add-baoxiu" @click="chooseImg( ind)" v-if="item.files.length<4" src="../../../../static/img/add-baoxiu.png">
              </li>
            </ul>
          </div>
        </div>
      </div>
      <footer class="sec5">
        <input type="button" class="btn" @click="confirm" value="提交">
        <div class="msk" v-if="finishShow"></div>
        <div class="pop" v-if="finishShow">
          <h4>提示</h4>
          <p>您的装修申请已提交，我们会及时联系您进行沟通装修事宜！</p>
          <input type="button"class="popBtn" @click="closePop" value="知道了" >
        </div>
      </footer>
      <img id='loading' src="../../../../static/img/loading2.gif"  v-if="isDisplay"  />
    </div>
</template>

<script>
  import axios from 'axios'
  import oSelect from '../../Son/select.vue'//引入子组件
  // import DateTime from 'vue-date-time-m'
  export default {
        name: "decorationApp",
      components: {
        'oSelect':oSelect, //注册组件
        // DateTime
      },
      data(){
          return {
            builder: '', //施工单位
            builderresponser: '', //施工负责人
            buildebegindate: '请选择时间',
            buildetenddate: '请选择时间',
            Pk_house: '',
            pk_client: '',
            finishShow: false,
            //id: sessionStorage.getItem('el'),//房屋名称
            // houseid: sessionStorage.getItem('pk_house'),//房屋id-现在是pk-house
            selectData:{
              defaultIndex:0,//默认选中是第几个
              selectStatus:false,//通过这个来控制下拉框的显示和隐藏
              selectOptions:[]//下拉框中的参数
            },
            decorationList:[], //装修文件列表
            urlN9: '',
            accountCode: '',
            isDisplay: false,
          }
      },
      mounted(){
          this.getHouse()
          sessionStorage.setItem('btn-isDisabled',false)
      },
      methods:{
        // //  展示日期组件
        // show () {
        //   this.$refs.dateTime.show()
        // },
        // // 日期组件回调
        // select (val) {
        //   var reg = new RegExp("/","g");//g,表示全部替换。
        //   this.buildebegindate = val.replace(reg,'-')
        // },
        // //  展示日期组件
        // showEnd () {
        //   this.$refs.endDateTime.show()
        // },
        // // 日期组件回调
        // selectEnd (val) {
        //   var reg = new RegExp("/","g");//g,表示全部替换。
        //   this.buildetenddate = val.replace(reg,'-')
        // },
        //提交按钮
        confirm(){
          let _this = this;
          if(_this.Pk_house && _this.pk_client && _this.builder && _this.builderresponser && _this.buildebegindate && _this.buildetenddate ){
            if( sessionStorage.getItem('btn-isDisabled') === 'false' ){
              sessionStorage.setItem('btn-isDisabled',true)
              _this.postRequestN9(_this.urlN9 + '/LsInterfaceServer/phoneServer/adddecorate',{
                pk_house: _this.Pk_house,
                pk_client: _this.pk_client,
                builder: _this.builder,
                builderresponser: _this.builderresponser,
                buildebegindate: _this.buildebegindate,
                buildetenddate: _this.buildetenddate,
                decorationList: JSON.stringify(_this.decorationList),
                accountCode: _this.accountCode
              },function (data) {
                console.log(data)
                _this.finishShow = true
              })
            }else{
              alert('请勿重复提交！')
            }
          }else{
            alert('请填写完整装修信息！')
          }
        },
          //获取装修文件的类型
        getDecorationStyle(){
          let _this = this;
          console.log(_this.urlN9)
          _this.postRequestN9( _this.urlN9 + '/LsInterfaceServer/phoneServer/querydecdocslist',{
          },function (data) {
            let styleList = data.array
            _this.decorationList = styleList.map((v,i)=>{
              v.files=[]
              v.file=[]
              return v
            })
            console.log(_this.decorationList)
          })
        },
        //获取房屋
        getHouse(){
          let _this = this;
          _this.postRequest('house/validateAllHouseList', {}, function (data) {
            _this.selectData.selectOptions = data
            console.log(data)
            _this.urlN9 = data[0].sysUrl
            _this.accountCode = data[0].accountCode
            _this.Pk_house = data[0].pkHouse
            _this.pk_client = data[0].pkClient
            console.log(_this.Pk_house)
            _this.getDecorationStyle();
          })
        },
        //选择下拉的列表
        onChangeOption(index,id,name,accountCode,sysUrl,pkHouse){
          this.selectData.defaultIndex=index
          this.Pk_house = pkHouse
          this.accountCode = accountCode
          this.urlN9 = sysUrl
          this.selectData.selectOptions.map(v=>{
            if(pkHouse === v.pkHouse){
              this.pk_client = v.pkClient
            }
          })
          sessionStorage.setItem('el', name)
        },
          //装修文件
        close (item,val) {
          console.log(item)
          console.log(val)
          item.file.splice(val,1)
          item.files.splice(val,1)
        },
        chooseImg (index) {
          const refDom = this.$refs['choose' + index][0]
          refDom.value = null
          refDom.click()
        },
        setImagePreview(item, event) {
          item.files.push(window.URL.createObjectURL(event.target.files[0]))
          let filess = event.target.files || event.dataTransfer.files
          if (item.files.length === 0) return;
          this.createImage (item,filess, event)
        },
        createImage (item,file ,event) {
          this.lrz(file[0],{
            width:100,
            quality:.5
          }).then(function(rst) {
            item.file.push(rst.base64)
            return item.file;
          }).always(function() {
            event.target.value = null;
          })
        },
        //关闭提示弹框
        closePop(){
          let _this = this;
          _this.finishShow = false
          _this.$router.push('homePageBeiDaZiYuan')
        }
      }
    }
</script>

<style scoped>
   input[type=date] {

    background-color:transparent;

    color:#000;

    FILTER: alpha(opacity=0); /*androd*/

    appearance:none;  /*下拉框去掉右侧图标*/

    -moz-appearance:none;

    -webkit-appearance:none;
    width: 6rem;
    height: .5rem;
    font-size:.4rem;
     color: #999;
  }
  ::-webkit-input-placeholder {
    color:#999 !important;
  }
  :-moz-placeholder{
    color:#999 !important;
  }
  :-ms-input-placeholder{
    color:#999 !important;
  }
  .msk{
    width: 100%;
    background: rgba(0,0,0,.8);
    height: 1334px;
    z-index: 10;
    position: fixed;
    top: 0;
  }
  .pop{
    z-index: 20;
    background: #fff;
    width: 88%;
    border-radius:5px;
    position: fixed;
    top: 40%;
    left: 50%;
    transform: translateX(-50%);
  }
  .pop h4{
    height: 1rem;
    line-height: 1rem;
    font-size: .5rem;
    border-bottom: 1px solid #E4E4E4;
  }
  .pop p{
    height: 1.3rem;
    line-height: .7rem;
    padding: 0 .3rem;
    box-sizing: border-box;
    margin-top: .1rem;
    text-align: center;
    font-size: .4rem;
  }
  .popBtn{
    margin: .5rem 0;
    width: 40%;
    height: 1rem;
    border: 2px solid #F7B932;
    border-radius: .5rem;
    background-color: #fff;
    font-size: 32px;
    color: #F7B932;
    z-index: 20;
  }
  .chooseHouse{
    display: flex;
    justify-content: flex-start;
    height: 1.5rem;
    line-height: 1.5rem;
    margin-bottom: .2rem;
  }
  .chooseHouse .houseSelect{
    width: 80%;
    margin-top: .4rem;
  }
  .decorationApp{
    width: 100%;
    margin: 0 auto;
    text-align: left;
  }
  .decorationMain{
    width: 94%;
    margin: 0 auto;
    text-align: left;
  }
  .constructionUnit, .constructionManager, .planStartTime, .planEndTime{
    height: 1.3rem;
    line-height: 1.3rem;
    display: flex;
    justify-content: flex-start;
    border-bottom: 1px solid #ececec;
    margin-bottom: .3rem;
  }
  .constructionFile{
    margin-top: .5rem;
  }
  .constructionFile ul{
    margin-bottom: .5rem;
    display: flex;
    justify-content:left;
  }
  .constructionFile ul .add-baoxiu{
    width: 120px;
    height: 120px;
  }
  .constructionFile ul .preview{
    width: 130px;
    height: 130px;
  }
  .constructionFile ul .close{
    width: 35px;
    height: 35px;
    position: relative;
    top: -114px;
    left: -26px;
  }
.c333{
  font-size: .42rem;
  color: #333;
}
.c25{
  color: #999;
  font-size: .4rem;
}
  .mb10{
    margin-bottom: .4rem;
  }
  .mr10{
    margin-right: .3rem;
  }
  .mt10{
    margin-top: 1rem;
  }
  .sec5{
    text-align: center;
  }
  .sec5 .btn{
    /*margin: 104px 0 60px 0;*/
    margin: .5rem 0;
    width: 90%;
    height: 80px;
    border-radius: 40px;
    background: -webkit-linear-gradient(left, #FFA650,#F7B932); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(right,  #FFA650,#F7B932); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(right, #FFA650,#F7B932); /* Firefox 3.6 - 15 */
    background: linear-gradient(to right,  #FFA650,#F7B932); /* 标准的语法 */
    font-size: 32px;
    color:#fff;
    z-index: 1000;
    /*position: fixed;*/
    /*bottom: .4rem;*/
    /*left: 5%;*/
  }

</style>



// WEBPACK FOOTER //
// src/components/pub-component/decoration/decorationApp.vue